import { useNavigate, useParams } from 'react-router-dom'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import { useEffect, useState } from 'react'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import eventBus from 'services/eventBus'
import { useSetRecoilState } from 'recoil'
import recoilStateUpdaters from 'recoil/recoil.stateUpdaters'
import useProjectType from '../../hooks/useProjectType'
import projectTypesTableAtom from '../../components/ProjectTypesTable/projectTypesTable.atom'
import projectTypesApi from '../../projectTypes.api'
import ProjectTypeSheet from '../../components/ProjectTypeSheet'
import ConfirmDeleteModal from 'shared/Modal/ConfirmDeleteModal'

const ProjectTypePage = () => {
  const { wait, loading: updateLoading } = useHttpLoader()
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  
  const navigate = useNavigate()

  const params = useParams()
  const id = params.id
  const { projectType, loading } = useProjectType(id)
  const [draft, setDraft] = useState(projectType)
  const setState = useSetRecoilState(projectTypesTableAtom)

  useEffect(() => {
    setDraft(projectType)
  }, [projectType])

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(projectTypesApi.update(draft, id), (resp) => {
      if (resp.status === 'success') {
        recoilStateUpdaters.itemUpdated(setState, resp.body)
        eventBus.pub('ntf.message', { type: 'info', message: 'Тип проекта обновлен' })
      }
    })
  }

  const renderContent = () => {
    if (!draft || loading) {
      return (
        <div className='flex-page-center'>
          <ThreeDotsLoader />
        </div>
      )
    }

    const handleDelete = () => {
      wait(projectTypesApi.remove(id), resp => {
        if(resp.status === 'success') {
          recoilStateUpdaters.itemRemoved(setState, resp.body.id)
          navigate('/admin/project-types')
        }
      })
    }

    return (
      <>
        {isOpenDeleteModal && (
          <ConfirmDeleteModal
            onDelete={handleDelete}
            onClose={() => setIsOpenDeleteModal(false)}
            entityName='тип проекта'
          />
        )}
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Тип проекта</h2>
          </div>
        </div>
        <ProjectTypeSheet projectType={draft} onChange={handleChange}>
          <div className='inline-flex-gap' style={{ gap: '1em' }}>
            <Button theme='primary' loading={updateLoading} style={{ width: 'fit-content' }} onClick={handleSave}>
              Сохранить
            </Button>
            <Button
              theme='danger'
              loading={updateLoading}
              style={{ width: 'fit-content' }}
              onClick={() => setIsOpenDeleteModal(true)}
            >
              Удалить
            </Button>
          </div>
        </ProjectTypeSheet>
      </>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='adminWithBackButton'>{renderContent()}</TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectTypePage
